module.exports = __webpack_public_path__ + "static/img/020_TO8_1484_og.d63a737.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/020_TO8_1484_og.jpg
// module id = 7vUq
// module chunks = 0